// Redux
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { columnService } from '../services/columnService';

const fetchColumns = createAsyncThunk('column/fetchColumns', async (numBoard) => {
 console.log('Passou aqui no fetchColumns do columnSlice, numBoard:', numBoard);
  //const response = await columnService.getColumns(numBoard);
  const response = await columnService.getColumn(numBoard);
  return response;
});

const createColumn = createAsyncThunk('column/createColumn', async ({ numBoard, columnName }) => {
  const response = await columnService.createColumn(numBoard, columnName);
  return response;
});

const updateColumn = createAsyncThunk('column/updateColumn', async ({ numColumn, name }) => {
  const response = await columnService.updateColumn(numColumn, name);
  return response;
});

const columnSlice = createSlice({
  name: 'column',
  initialState: {
        list : [], // Lista de boards
        loading: false, // Indicador de carregamento
        error: null, // Armazenar erros
  },
  reducers: {
    setColumns: (state, action) => {
      state.list = action.payload;
    },
  },  
    extraReducers: (builder) => {
    builder
        // Fetch Columns
        .addCase(fetchColumns.pending, (state) => {
            state.loading = true; // Inicia o carregamento
            state.error = null; // Limpa erros anteriores
        })
        .addCase(fetchColumns.fulfilled, (state, action) => {
            state.loading = false; // Termina o carregamento
            state.list = action.payload; // Atualiza a lista de columns
        })
        .addCase(fetchColumns.rejected, (state, action) => {
            state.loading = false; // Termina o carregamento
            state.error = action.error.message; // Armazena o erro
        })  

        // Create Column
        .addCase(createColumn.pending, (state) => {
            state.loading = true; // Inicia o carregamento
            state.error = null; // Limpa erros anteriores
        })
        .addCase(createColumn.fulfilled, (state, action) => {
            state.loading = false; // Termina o carregamento
            state.list.push(action.payload); // Adiciona o novo column à lista
        })
        .addCase(createColumn.rejected, (state, action) => {
            state.loading = false; // Termina o carregamento
            state.error = action.error.message; // Armazena o erro
        })

        // Update Column
        .addCase(updateColumn.pending, (state) => {
            state.loading = true; // Inicia o carregamento
            state.error = null; // Limpa erros anteriores
        })
        .addCase(updateColumn.fulfilled, (state, action) => {
            state.loading = false; // Termina o carregamento
            const index = state.list.findIndex((column) => column.num === action.payload.num);
            if (index !== -1) {
                state.list[index] = action.payload; // Atualiza o column na lista
            }
        })
        .addCase(updateColumn.rejected, (state, action) => {
            state.loading = false; // Termina o carregamento
            state.error = action.error.message; // Armazena o erro
        })
    }
});

export const { setColumns } = columnSlice.actions
export { fetchColumns, createColumn, updateColumn }
export default columnSlice.reducer;